w<template>
  <div :class="activityClass">
    <div 
      v-if="showProgress"
      class="progress">
      <div
        class="progress-bar progress-bar-info"
        role="progressbar"
        :aria-valuenow="count/target * 100"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="`width: ${count/target * 100}%`"></div>
    </div>
    <div :class="{ 'card-body': true, 'py-2': variant !== 'nested', 'p-0': variant === 'nested' }">
      <div class="media">
        <div class="media-body align-self-center">
          <div class="media">
            <div 
              v-if="showIcon"
              class="media-left">
              <i :class="`fa fa-fw ${icon || 'fa-block'} mr-2`"></i>
            </div>
            <div class="media-body">
              {{ label }}
            </div>
          </div>
          <small
            v-if="tip"
            class="d-block mt-1 text-muted">
            {{ tip }}
          </small>
        </div>
        <div 
          v-if="showIncrementDecrement"
          class="media-right align-self-center text-right">
          <div class="d-flex align-items-center">
            <button
              class="btn btn-sm btn-secondary" @click.prevent="count = Math.max(0, count-1)"
              :disabled="count < 1"
            >
              <i class="fa fa-fw fa-minus"></i>
            </button>
            <span class="h2 mb-0 pb-0 font-weight-normal mx-2">
              {{ displayCount }}
            </span>
            <button class="btn btn-sm btn-secondary mr-1" @click.prevent="count++">
              <i class="fa fa-fw fa-plus"></i>
            </button>
          </div>
        </div>
        <div
          v-if="showToggle"
          class="media-right align-self-center text-right">
          <div class="d-flex align-items-center">
            <span class="h2 mb-0 pb-0 font-weight-normal mx-2">
              {{ displayCount }}
            </span>
            <button class="btn btn-sm btn-secondary mr-1" @click.prevent="showNested = !showNested">
              <i
                v-show="!showNested" 
                class="fa fa-fw fa-plus"></i>
              <i
                v-show="showNested" 
                class="fa fa-fw fa-caret-up"></i>
            </button>
          </div>
        </div>
      </div>
      <div 
        v-if="showNested"
        class="nested">
        <hr v-if="variant !== 'nested'">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  .progress {
    border-radius: 0;
    height: 15px;
  }
}
</style>

<script>
// import Slider from '@/components/Slider'

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'fa-block'
    },
    value: {
      type: Number,
      default: 0
    },
    history: {
      type: Number,
      default: null
    },
    target: {
      type: Number,
      default: 0
    },
    tip: {
      type: String
    },
    variant: {
      type: String,
      default: 'tracker'
    }
  },
  computed: {
    showIncrementDecrement () {
      return this.variant === 'tracker' || this.variant === 'nested'
    },
    showToggle () {
      return this.variant === 'container'
    },
    showProgress () {
      return this.target && this.variant !== 'nested'
    },
    activityClass () {
      return `${this.variant !== 'nested' ? 'card' : 'mb-2'} tracker-${this.variant}`
    },
    showIcon () {
      return this.variant !== 'nested'
    },
    displayCount () {
      return (this.history || 0) + this.count
    }
  },
  components: {
    // Slider
  },
  data () {
    return {
      showNested: false,
      count: this.value
    }
  },
  watch: {
    history () {
      //
    },
    value () {
      this.count = this.value
    },
    count () {
      this.$emit('input', this.count)
    }
  }
}
</script>